export enum PaymentMethod {
	PAYPAL = 'paypal',
	PAYPAL_ADYEN = 'paypal_adyen',
	CASH = 'cash',
	CREDIT_CARD = 'credit_card',
	VISA = 'visa',
	MASTERCARD = 'mastercard',
	SEPA = 'sepa',
	BALANCE = 'balance',
	POS = 'pos',
	SOFORTBANKING = 'sofortbanking',
	GPAY = 'google_pay',
	APAY = 'apple_pay',
	CCV = 'ccv',
	ADYEN = 'adyen',
	ZERO_PAYMENT = 'zero_payment',
}
